import { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'success' | 'warning' | 'error';
}

export const Badge = ({
  className,
  variant = 'default',
  children,
  ...props
}: BadgeProps) => {
  const variants = {
    default: 'text-domino-aubergine',
    secondary: 'text-domino-inkSoft',
    outline: 'text-domino-inkSoft',
    success: 'text-green-700',
    warning: 'text-[var(--domino-warning)]',
    error: 'text-red-700',
  };

  return (
    <span
      className={cn(
        className,
        'inline-flex items-center border-0 bg-transparent p-0 text-xs font-medium hover:bg-transparent',
        variants[variant]
      )}
      {...props}
    >
      {children}
    </span>
  );
};
